import { cn } from "cn";
import { useTheme } from "next-themes";
import {
  Tabs,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs/tabs-contained";
import {
  BwLightDarkModeLine,
  BwMoonLine,
  BwPaintingPaletteLine,
  BwSunLine,
} from "./ui/icons";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";

export function ThemeSwitch({ className }: { className?: string }) {
  const { theme, setTheme } = useTheme();
  const value = theme ?? "system";

  const onValueChange = (next: string) => {
    setTheme(next as "light" | "dark" | "system");
  };

  return (
    <div className={cn("flex items-center gap-2 w-full", className)}>
      <BwPaintingPaletteLine className="size-5 text-text-dark-high" />
      <p className="grow text-sm text-text-dark-max">Theme</p>
      <Tabs value={value} onValueChange={onValueChange}>
        <TabsList>
          <TabsTrigger value="light" className="px-2 py-1.5">
            <Tooltip>
              <TooltipTrigger className="cursor-pointer" asChild>
                <BwSunLine className="size-5" />
              </TooltipTrigger>
              <TooltipContent>Light</TooltipContent>
            </Tooltip>
          </TabsTrigger>
          <TabsTrigger value="dark" className="px-2 py-1.5">
            <Tooltip>
              <TooltipTrigger className="cursor-pointer" asChild>
                <BwMoonLine className="size-5" />
              </TooltipTrigger>
              <TooltipContent>Dark</TooltipContent>
            </Tooltip>
          </TabsTrigger>
          <TabsTrigger value="system" className="px-2 py-1.5">
            <Tooltip>
              <TooltipTrigger className="cursor-pointer" asChild>
                <BwLightDarkModeLine className="size-5" />
              </TooltipTrigger>
              <TooltipContent>System theme</TooltipContent>
            </Tooltip>
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
}
